const logos = document.querySelectorAll('.logos');
logos.forEach(logo => {
  let logosUK = logo.querySelectorAll('.t-logo');
  let logosEU = logo.querySelectorAll('.t-european-logo');
  logo.querySelector('.logo-uk').addEventListener('click', function (event) {
    event.preventDefault();
    logosUK.forEach(logoUK => {
      logoUK.classList.remove('hidden');
    });
    logosEU.forEach(logoEU => {
      logoEU.classList.add('hidden');
    });
  });
  logo.querySelector('.logo-eu').addEventListener('click', function (event) {
    event.preventDefault();
    logosUK.forEach(logoUK => {
      logoUK.classList.add('hidden');
    });
    logosEU.forEach(logoEU => {
      logoEU.classList.remove('hidden');
    });
  });
  const logoAll = document.querySelectorAll(".logo-all");

  for (let i = 0; i < logoAll.length; i++) {
    logoAll[i].addEventListener("click", function (event) {
      event.preventDefault();
      logosUK.forEach(logoUK => {
        logoUK.classList.remove('hidden');
      });
      logosEU.forEach(logoEU => {
        logoEU.classList.remove('hidden');
      });
    });
  }

});
